import { observer } from 'mobx-react'
import React from 'react'

@observer
class SlideItem extends React.Component {
  render () {
    const { clickAction, item: { content, id }, vertical, className, onMouseDown, style } = this.props
    const wrapperClass = `sidebar-slide__slide-item ${className ? className : ''}`
    const colClass = vertical ? 'vertical-columns__content' : 'col-xl-6 col-md-12'
    return (
      <div 
        className={colClass} 
        onClick={clickAction}
        onMouseDown={onMouseDown}
        draggable
      >
        <div 
          className={wrapperClass}
          style={style || {}}
        >
          {content}
        </div>
      </div>
    )
  }
}

export default SlideItem
